import { type FC, type FocusEventHandler, type MouseEventHandler, type TdHTMLAttributes } from 'react';
import { isElementTruncated } from '@/hooks/useIsTruncated';

export const CELL_TOOLTIP_ID = 'agent-table-cell-tooltip';

const updateTooltipContent = (cellElement: HTMLTableCellElement) => {
  const textContent = cellElement.textContent?.trim();

  if (!textContent || !isElementTruncated(cellElement)) {
    cellElement.removeAttribute('data-tooltip-content');
    return;
  }

  cellElement.setAttribute('data-tooltip-content', textContent);
};

const AgentTableCell: FC<TdHTMLAttributes<HTMLTableCellElement>> = ({ children, ...props }) => {
  // Content is derived on enter and intentionally not cleared on leave: the tooltip is
  // clickable, so the cursor moving from the cell into the tooltip fires mouseLeave here.
  // Clearing content on leave would wipe the text while the user is selecting it.
  const handleMouseEnter: MouseEventHandler<HTMLTableCellElement> = event => {
    updateTooltipContent(event.currentTarget);
  };

  const handleFocus: FocusEventHandler<HTMLTableCellElement> = event => {
    updateTooltipContent(event.currentTarget);
  };

  return (
    <td data-tooltip-id={CELL_TOOLTIP_ID} onMouseEnter={handleMouseEnter} onFocus={handleFocus} {...props}>
      {children}
    </td>
  );
};

export default AgentTableCell;
